module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/experiences/experiences_01-neeraactivities.png";